import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useGlobalContext } from "../Config";


const FormCrearProductoSubproducto = ({
    displayDialogProductoSubproducto,
    setDisplayDialogProductoSubproducto,
    empresa,
    loading,
    setLoading,
    baseUrl,
    nombreEmpresa,
    productos,
    fetchData
}) => {
    const [cantidad, setCantidad] = useState(0);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [subproductos, setSubproductos] = useState([]);
    const [selectedSubproducto, setSelectedSubproducto] = useState(null);
    const { baseUrl: ctxBaseUrl } = useGlobalContext();

    const buildInsertSubproductoUrl = (
        idEmpresa,
        idProducto,
        idTipoSubproducto,
        metraje
    ) => {
        const urlBase = baseUrl || ctxBaseUrl;
        return `${urlBase}insertProductoSubproducto?idEmpresa=${idEmpresa}&idProducto=${idProducto}&idTipoSubproducto=${idTipoSubproducto}&metraje=${metraje}&incluido=${true}`;
    };

    const cerrarYLimpiar = () => {
        setSelectedProduct(null);
        setSelectedSubproducto(null);
        setCantidad(0);
        setSubproductos([]);
        setDisplayDialogProductoSubproducto(false);
    };

    const loadSubproductos = async () => {
        try {
            setLoading?.(true);
            const urlBase = baseUrl || ctxBaseUrl;
            const resp = await fetch(`${urlBase}getSubproductosByEmpresa?empresa=${nombreEmpresa}`);
            const data = await resp.json();
            setSubproductos(Array.isArray(data.subproductos) ? data.subproductos : []);
        } catch (e) {
            console.error("Error al obtener subproductos:", e);
        } finally {
            setLoading?.(false);
        }
    };

    useEffect(() => {
        setProducts(Array.isArray(productos) ? productos : []);
    }, [productos]);

    useEffect(() => {
        if (displayDialogProductoSubproducto && nombreEmpresa) {
            loadSubproductos();
        }
    }, [displayDialogProductoSubproducto, nombreEmpresa]);

    const handleInsert = async () => {
        if (!empresa || !selectedProduct?.id || !selectedSubproducto?.id || !cantidad) return;
        try {
            setLoading?.(true);
            const insertUrl = buildInsertSubproductoUrl(
                empresa,
                selectedProduct.id,
                selectedSubproducto.id,
                cantidad
            );
            const res = await fetch(insertUrl, { method: "POST", redirect: "follow" });
            if (!res.ok) {
                throw new Error(`Error al insertar subproducto. Status: ${res.status}`);
            }
            alert("Subproducto asociado correctamente.");
            cerrarYLimpiar();
        } catch (error) {
            console.error("Error insertando subproducto:", error);
            alert(error.message || "Error al asociar subproducto");
        } finally {
            fetchData();
        }
    };

    return (
        <Dialog
            header={`Asociar Subproducto: ${nombreEmpresa || "sin nombre"}`}
            visible={displayDialogProductoSubproducto}
            className="p-fluid product-dialog"
            onHide={cerrarYLimpiar}
            footer={
                <div className="flex justify-content-end">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-rounded p-button-outlined"
                        onClick={cerrarYLimpiar}
                    />
                    <Button
                        label="Guardar"
                        icon="pi pi-save"
                        className="p-button-rounded p-button-success p-button"
                        raised
                        onClick={handleInsert}
                        disabled={!selectedProduct || !selectedSubproducto || !cantidad || loading}
                    />
                </div>
            }
        >
        <div className="p-grid p-formgrid p-fluid">
            {/* SECCIÓN 1: SELECCIÓN DE TIPO Y PRODUCTOS */}
            <div className="col-12 mb-2">
                <div className="p-card p-3">
                    <h6 className="mb-3">
                        Sub Producto Adicional
                        <span className="block text-sm text-gray-600 mt-1">
                            {selectedProduct?.metraje ? `(Máximo permitido: ${selectedProduct.metraje} m²)` : ""}
                        </span>
                    </h6>
                    <span className="p-float-label mt-2 mb-2">
                        <Dropdown
                            value={selectedProduct}
                            options={products}
                            onChange={(e) => setSelectedProduct(e.value)}
                            optionLabel="descripcion"
                            placeholder="Seleccione un producto"
                            className="w-full"
                        />
                        <label htmlFor="producto">Producto ({nombreEmpresa})</label>
                    </span>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                        <span className="p-float-label" style={{ width: "100%" }}>
                            <Dropdown
                                id="tipoSubP"
                                value={selectedSubproducto}
                                onChange={(e) => setSelectedSubproducto(e.value)}
                                options={subproductos}
                                optionLabel="descripcion"
                                placeholder="Seleccione un subproducto"
                                className="w-full"
                            />
                            <label htmlFor="tipoSubP">Subproducto ({nombreEmpresa})</label>
                        </span>

                        <span className="p-float-label" style={{ width: "100%" }}>
                            <InputNumber
                                id="metrajeSubp"
                                value={cantidad}
                                onChange={(e) => setCantidad(e.value || 0)}
                                min={1}
                                placeholder="Ingrese cantidad en metros"
                                max={selectedProduct?.metraje}
                                className="w-full"
                                inputStyle={{ width: "100%" }}
                            />
                            <label htmlFor="metrajeSubp">Metros</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        </Dialog>
    );
};

export default FormCrearProductoSubproducto;
